<layout>

<div class="insets background" style="min-height: 80vh">

<div class="betweenRow">
    <div [@item] class=center *ngIf="authLevel !== 'instructor' && authLevel !== 'admin'" >
        <h2>
            👋 Hi {{profile?.firstname}}, 
            We're setting up your profile.  If you don't see your Bible school here in a couple minutes, 
            try refreshing your page. <br/>
            If you still don't see your Bible school, <a routerLink="/contact-us">Contact us.</a>
        </h2>
    </div>
    <mat-form-field *ngIf="!!profile && !!profile?.organization" appearance="fill">
    <mat-label>Organization</mat-label>

    

    <mat-select 

    (selectionChange)="orgnizationChange($event)"
    [(value)]="profile.organization">
        <mat-option *ngFor="let o of orgs" [value]="o">
        {{o.name}}
        </mat-option>
    </mat-select>
    </mat-form-field>
    
    <!-- <button 
        mat-raised-button color="warn" 
        matTooltip="Link this organization with It Is Written's Outreach Database"
        (click)=gotoLink()
        *ngIf="!orgs[profile?.organization]?.outreach_id">Link to Outreach</button> -->
    <button 
    mat-flat-button 
    style="font-weight: bold" 
    [cdkCopyToClipboard]="invitationLink"
    matTooltip="Copy"> www.itiswritten.study/register/{{org?.entityId}}</button>
    </div > 


    <mat-tab-group mat-align-tabs="center" *ngIf="authLevel === 'instructor'" >
        <mat-tab  label="Messages">
            <ng-template matTabContent>
            <app-my-school-contacts
                authLevel="{{authLevel}}"
                *ngIf="!!org"
                uid="{{profile?.uid}}"
                firstname="{{profile?.firstname | titlecase}}"
                lastname="{{profile?.lastname | titlecase}}"
                entityId="{{org?.entityId}}"
                orgName="{{org?.name}}"
                orgId="{{org?.id}}"
            ></app-my-school-contacts>
            </ng-template>
        </mat-tab>
        <mat-tab label="Contacts">
            <ng-template matTabContent>    
                <app-contacts-page
                    entityId="{{org?.entityId}}"
                    orgId="{{org?.id}}">
                </app-contacts-page>
            </ng-template>
        </mat-tab>
        <mat-tab label="Lessons">
            <ng-template matTabContent>    
                <app-auto-unlock-lessons
                    authLevel="{{authLevel}}"
                    >
                </app-auto-unlock-lessons>
            </ng-template>
        </mat-tab>
        <mat-tab label="Instructors">
            <ng-template matTabContent>
            <app-my-school-instructor 
                name="{{profile?.firstname + ' ' + profile?.lastname}}"
                orgName="{{org?.name}}"
                orgId="{{org?.id}}">
            </app-my-school-instructor>
            </ng-template>
        </mat-tab>
        <mat-tab label="My Profile">
            <ng-template matTabContent>
                <app-user-profile>

                </app-user-profile>
            </ng-template>
        </mat-tab>
        
    </mat-tab-group>
    <mat-tab-group mat-align-tabs="center" *ngIf="authLevel === 'admin'"  >
 
        <mat-tab  label="Messages">
            <ng-template matTabContent>
            <app-my-school-contacts 
            authLevel="{{authLevel}}"
            *ngIf="!!org"
            uid="{{profile?.uid}}"
            firstname="{{profile?.firstname | titlecase}}"
            lastname="{{profile?.lastname | titlecase}}"
            entityId="{{org?.entityId}}"
            orgName="{{org?.name}}"
            orgId="{{org?.id}}">
            </app-my-school-contacts>
            </ng-template>

        </mat-tab>
        <mat-tab label="Contacts">
            <ng-template matTabContent>    
                <app-contacts-page
                    entityId="{{org?.entityId}}"
                    orgId="{{org?.id}}">
                </app-contacts-page>
            </ng-template>
        </mat-tab>
        <mat-tab label="Lessons">
            <ng-template matTabContent>    
                <app-auto-unlock-lessons
                    authLevel="{{authLevel}}"
                    entityId="{{org?.entityId}}"
                    orgId="{{org?.id}}">
                </app-auto-unlock-lessons>
            </ng-template>
        </mat-tab>
        <mat-tab label="Instructors">
            <ng-template matTabContent>
            <app-my-school-instructor 
                showAddButton="true"
                name="{{profile?.firstname + ' ' + profile?.lastname}}"
                entityId="{{org?.entityId}}"
                orgName="{{org?.name}}"
                orgId="{{org?.id}}">
            </app-my-school-instructor>
            </ng-template>
        </mat-tab>
        <mat-tab label="Church Details">
            <ng-template matTabContent>
            <app-my-school-admin 

            orgId="{{org?.id}}">
            </app-my-school-admin>
            </ng-template>
        </mat-tab>
        <mat-tab label="My Profile">
            <ng-template matTabContent>
                <app-user-profile>

                </app-user-profile>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>

</layout>